export const formatTime = (date) => {
    if (!(date instanceof Date)) {
      // Handle Firestore timestamp
      if (date && date.toDate) {
        date = date.toDate();
      } else {
        return 'Unknown time';
      }
    }
    return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  };